var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConvertshape2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16687 13.4527V15.7024C9.16687 17.5771 8.41698 18.327 6.54226 18.327H4.29258C2.41786 18.327 1.66797 17.5771 1.66797 15.7024V13.4527C1.66797 11.578 2.41786 10.8281 4.29258 10.8281H6.54226C8.41698 10.8281 9.16687 11.578 9.16687 13.4527Z",
    stroke: "#344054",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3325 12.5C18.3325 15.7245 15.7245 18.3325 12.5 18.3325L13.3749 16.8744",
    stroke: "#344054",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 7.49654C1.66797 4.27201 4.27592 1.66406 7.50045 1.66406L6.62558 3.12218",
    stroke: "#344054",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5815 9.16296C16.6522 9.16296 18.3309 7.48428 18.3309 5.41351C18.3309 3.34275 16.6522 1.66406 14.5815 1.66406C12.5107 1.66406 10.832 3.34275 10.832 5.41351C10.832 7.48428 12.5107 9.16296 14.5815 9.16296Z",
    stroke: "#344054",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertshape2);
export default __webpack_public_path__ + "static/media/convertshape-2.b1380277081e19a69ebbc5dcfcd23776.svg";
export { ForwardRef as ReactComponent };